import { render, staticRenderFns } from "./actPreview.vue?vue&type=template&id=71646cf8&scoped=true&"
import script from "./actPreview.vue?vue&type=script&lang=js&"
export * from "./actPreview.vue?vue&type=script&lang=js&"
import style0 from "./actPreview.vue?vue&type=style&index=0&id=71646cf8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71646cf8",
  null
  
)

component.options.__file = "actPreview.vue"
export default component.exports